import {List} from 'immutable';
import {type Observable} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BillPayerModel from 'web-app/react/entities/bill-payers/model';
import {type REVENUE_FILTER} from 'web-app/react/plans/revenue-report/constants';
import {type RevenueProgressResult} from 'web-app/react/plans/revenue-report/types';

const formatRevenueResponse = response => ({
    ...response,
    billPayers: List(Object.values(response.billPayers)).map(billPayer => BillPayerModel.fromAPI(billPayer)),
});
export const fetchInstitutionRevenueProgress = (
    institutionId: string,
    from: string,
    to: string,
): Observable<RevenueProgressResult> => {
    return RESTClient.getAuthenticatedObservable('v2/sessions/reports/revenueOverview/v2/refresh/progress', {
        institutionId,
        from,
        to,
    });
};
export const fetchOrganizationRevenueProgress = (
    organizationId: string,
    from: string,
    to: string,
): Observable<RevenueProgressResult> => {
    return RESTClient.getAuthenticatedObservable('v2/sessions/reports/orgRevenueOverview/v2/refresh/progress', {
        organizationId,
        from,
        to,
    });
};

export const fetchInstitutionRevenueOverview = (
    institutionId: string,
    from: string,
    to: string,
    refresh: boolean,
    filter: REVENUE_FILTER | null,
) => {
    const data: any = {
        institutionId,
        from,
        to,
        periodTotals: true,
    };

    if (filter) {
        data.filter = filter;
    }

    return RESTClient.dispatchAuthenticatedRequestObservable({
        endpoint: `v2/sessions/reports/revenueOverview/v2${refresh ? '/refresh' : ''}`,
        data,
        method: refresh ? 'POST' : 'GET',
    }).map(response => {
        if (response.refreshRequestedAt) {
            return response;
        }
        return formatRevenueResponse(response);
    });
};

export const fetchOrganizationRevenueOverview = (
    organizationId: string,
    from: string,
    to: string,
    refresh: boolean,
    filter: REVENUE_FILTER | null,
) => {
    const data: any = {
        organizationId,
        from,
        to,
        periodTotals: true,
    };

    if (filter) {
        data.filter = filter;
    }

    return RESTClient.dispatchAuthenticatedRequestObservable({
        endpoint: `v2/sessions/reports/orgRevenueOverview/v2${refresh ? '/refresh' : ''}`,
        data,
        method: refresh ? 'POST' : 'GET',
    });
};
